import React, {Component} from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { formatDateTime } from "../../api";
import DBOrderItem from './dbOrderItem';
import { sendMailById, putToast } from "../../api";

const ORDER_SUCCESS_EMAIL_TEMPLATE = process.env.REACT_APP_ORDER_SUCCESS_EMAIL_TEMPLATE;

class DBOrders extends Component {
    constructor(props) {
        super(props);
        this.sendOrderNotification = this.sendOrderNotification.bind(this);

        this.state = {
            data: this.props.item,
            sendingText: ""
        };

    }

    onItemAction = (row) => {
        this.sendOrderNotification(row._id);
        putToast.success("Sent Email ...");

    };

    sendOrderNotification = (orderId) => {
        this.setState({sendingText: "..."})
        // order: 5e2865b130cc3f63a04b20bb
        sendMailById(ORDER_SUCCESS_EMAIL_TEMPLATE, [this.state.data._id], {order: orderId})
        this.setState({sendingText: ""})
    };
        
    render(){
            const { item } = this.props;

            return (                                
                <div className="dashboard-right">
                    <div className="dashboard">
                        <div className="page-title">
                            <h2>My Orders</h2>
                        </div>
                        <div className="welcome-msg">
                            <p>These are the orders we found for your account. </p><br/>
                        </div>
                        <div className="box-account box-info">
                            <div className="row">
                                <div className="col-sm-12">
                                    <ReactTable
                                        data={item.orders}
                                        columns={[{
                                            Header: 'TrxId',
                                            accessor: 'transactionId' // String-based value accessors!
                                          }, {
                                            Header: 'Date',
                                            accessor: 'createdAt',
                                            Cell: props => <span>{formatDateTime(new Date(props.value))}</span>
                                            
                                             // Custom cell components!
                                          }, {
                                            Header: 'Amount',
                                            accessor: 'amount'
                                          }, {
                                            Header: 'Status',
                                            accessor: 'status'
                                          }, {
                                            Header: <b>Action</b>,
                                            id: 'resend',
                                            accessor: str => "Re-Send",
                                            Cell: (row) => (
                                                <div>
                                                    <span onClick={() => this.onItemAction(row.original)}>
                                                        <i className="fa fa-paper-plane" style={{ width: 35, fontSize: 20, padding: 11,color:'rgb(40, 109, 167)' }}></i>
                                                    </span>
                                                </div>
                                        ),
                                        style: {
                                            textAlign: 'center'
                                        },
                                        sortable: false
                                    }]}                                        
                                        defaultPageSize={10}
                                        showPagination={true}
                                        SubComponent={row => {
                                            return (
                                                <DBOrderItem orderItems={row.original.items} />
                                            )}}
                                    />
                                </div>
                            </div>  
                        </div>
                    </div>
                </div>
        )
    }
}

export default DBOrders